import Box, { type BoxProps } from '@mui/material/Box';
import type { FC, ReactNode } from 'react';

interface FormGridProps extends Omit<BoxProps, 'display'> {
  children: ReactNode;
  /** Number of columns at md+. Default 2. */
  columns?: 1 | 2 | 3;
  /** MUI spacing units. Default 2.5 (= 20 px). */
  gap?: number;
}

const FormGrid: FC<FormGridProps> = ({ children, columns = 2, gap = 2.5, sx, ...rest }) => (
  <Box
    {...rest}
    sx={{
      display: 'grid',
      columnGap: gap,
      rowGap: gap,
      gridTemplateColumns: {
        xs: '1fr',
        sm: columns >= 2 ? `repeat(${Math.min(columns, 2)}, minmax(0, 1fr))` : '1fr',
        md: `repeat(${columns}, minmax(0, 1fr))`,
      },
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default FormGrid;
